/* =============================================================================
   mancha.js — la forma de la mancha del revelado y su geometría
   Hotel La Gruta · Arequipa

   Una sola fuente para quien dibuja la mancha (scroll-fx.js: recorte del mapa)
   y para quien necesita saber CUÁNDO termina de cubrir (vines.js: los
   ramilletes del mapa brotan al terminar la transición). Sin dependencias
   ni medición en el navegador: el radio interior viene precalculado.

   Espacio: el viewBox de la mancha (157 × 138), centro visual (78,5 ; 69).
   La mancha se escala uniformemente desde ese centro.
   ============================================================================= */
(function () {
  'use strict';

  var D = 'M89.1454 3.40301C86.0569 2.71787 77.9904 -0.634656 53.1436 1.40629C28.2967 3.44723 3.13592 24.9086 0.519881 71.1027C-2.09616 117.297 40.174 138.343 70.9733 137.171C99.1796 136.107 104.977 133.476 131.005 123.833C152.957 110.522 158.854 85.475 155.877 58.9547C153.081 34.0119 136.288 19.0839 116.816 11.1293C107.835 7.44991 94.0587 4.59237 89.1454 3.40301Z';
  var CX = 78.5, CY = 69, MARGEN = 1.12;
  // Radio del mayor círculo centrado que cabe dentro de la mancha: con él se
  // sabe cuánto escalarla para cubrir un rectángulo. Es una constante de la
  // forma D: se calculaba al cargar con 720 getPointAtLength sobre un <path>
  // temporal (≈0,6 s de CPU en móvil, más un layout forzado). Si cambia D,
  // recalcularlo: mínimo de hypot(q.x − CX, q.y − CY) sobre 720 puntos del
  // contorno (p.getPointAtLength(largo · i / 720)).
  var INTERIOR = 66.3048060425848;

  window.Mancha = {
    d: D, cx: CX, cy: CY,
    // La mancha cubre por completo el primer 60 % de la pantalla de recorrido;
    // el resto es pausa para leer. Lo comparten el recorte y la vegetación.
    cobertura: 0.6,
    radioInterior: function () { return INTERIOR; },
    // Escala que cubre un rectángulo w × h centrado en la mancha.
    cubre: function (w, h) { return Math.hypot(w / 2, h / 2) / INTERIOR * MARGEN; }
  };
})();
